import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContent, PageTitle } from 'nallian-shared-ui/lib/components';
import MyAppsOverview from '../../apps/components/MyAppsOverview';

const Overview = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('welcome')}</PageTitle>
      <PageContent>
        <MyAppsOverview />
      </PageContent>
    </>
  );
};

export default Overview;
